import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionAriaLabel: {
    defaultMessage: 'Return Payment Options',
    description: 'Aria label for the return payment options section',
    id: 'v/p50q',
  },
  sectionHeaderTitle: {
    defaultMessage: 'Return Payment Options',
    description: 'Header title for the return payment options section',
    id: 'V6gNSV',
  },
  refundMethodTitle: {
    defaultMessage: 'Select Refund Method',
    description: 'Title for the refund method selection in return payment section',
    id: 'nl4CE5',
  },
  shippingCostOptionsTitle: {
    defaultMessage: 'Customer Shipping Cost Options',
    description: 'Title for the customer shipping cost options in return payment section',
    id: '1p5mzU',
  },
});
